import * as React from 'react';
import {
  FlexLayout, GridLayout,
} from '../../../../../components';
import { Global, TemplateProps } from '../../../../../constants';
import { Collect } from '../Collect';
import { CollectTabProvisionGridHeader } from '../headers/CollectTabProvisionGridHeader';

/**
 * 화면 > 탭 > 지급내역
 * @window w_tb_e601w_sulchi_02
 * @category 설치수금현황
 */
export const CollectTabProvisionTemplate: React.FC<TemplateProps<Collect>> = ({
  scope,
}) => (
  <FlexLayout isVertical={true}>
    <GridLayout
      header={CollectTabProvisionGridHeader(scope)}
      rowHeight={Global.LAYOUT_GRID_HEIGHT_1}
      data={scope.state.dataProvision}
    elGrid="dataProvision"
    />
  </FlexLayout>
);
